import { render } from "./VipShop.vue?vue&type=template&id=8abf1316"
import script from "./VipShop.vue?vue&type=script&lang=js"
export * from "./VipShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/VipShop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8abf1316"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8abf1316', __exports__)) {
    api.reload('8abf1316', __exports__)
  }
  
  module.hot.accept("./VipShop.vue?vue&type=template&id=8abf1316", () => {
    api.rerender('8abf1316', render)
  })

}


export default __exports__